var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center"},[_c('div',{staticClass:"cat-container"},[(_vm.isGlowing)?_c('div',{staticClass:"cat-glow"}):_vm._e(),_c('v-btn',{staticClass:"rounded-lg cat-btn",style:({
        'background-color': '#310293',
        color: _vm.isGlowing ? '#00FFFF' : 'white',
        'z-index': 2,
        'text-transform': 'unset !important',
      }),attrs:{"elevation":"3","x-large":""},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{class:_vm.font},[_vm._v(_vm._s(_vm.item.label))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }